import React, { useEffect, useState, createContext } from 'react';

const defaultState = {
    promos: [],
    activeCode: null,
    updateCode: () => {},
    updatePromos: () => {},
}

export const PromoContext = createContext(defaultState)

export const PromoProvider = ({ children }) => {
    let [promos, setPromos] = useState({})
    let [activeCode, setActiveCode] = useState('')

    useEffect(() => {}, [promos])

    const updatePromos = (newPromos) => {
        setPromos(newPromos)
    }

    const updateCode = (code) => {
        setActiveCode(code)
    }

    return (
        <PromoContext.Provider
            value={{
                promos,
                activeCode,
                updateCode: updateCode,
                updatePromos: updatePromos,
            }}
        >
            {children}
        </PromoContext.Provider>
    )
}